import { CSSProperties } from 'react';
import { ContainerEtapa } from '../../../styles';
import { EtapaCadastroProps, EtapaContatoCadastro } from '../../..';
import TextField, { TextFieldSize } from '@/components/molecules/TextField';
import { Controller } from 'react-hook-form';
import TextFieldNumerosInternacionais from '@/components/organisms/TextFieldNumeroInternacionais';

type EtapaDadosPessoaisProps = EtapaCadastroProps &
  EtapaContatoCadastro & {
    style?: CSSProperties;
    inputSize?: TextFieldSize;
    styleConteudoDropdown?: CSSProperties;
    $hideTelephoneField?: boolean;
  };

export default function EtapaContato(props: EtapaDadosPessoaisProps) {
  const {
    $control,
    $errors,
    $register,
    style,
    $paisSelecionado,
    $selecionarPais,
    inputSize = 2,
    styleConteudoDropdown = {},
    $hideTelephoneField = false,
  } = props;
  return (
    <ContainerEtapa style={style}>
      <TextField
        $size={inputSize}
        $variant="surface"
        $state="placeholder"
        $error={$errors.email?.message ?? false}
        $label="Digite seu e-mail"
        $focusRing={false}
        $obrigatorio={true}
        $placeholder="E-mail"
        $name="email"
        $inputProps={$register('email')}
      />
      {$hideTelephoneField ? null : (
        <Controller
          name="telefone"
          control={$control}
          render={({ field }) => (
            <TextFieldNumerosInternacionais
              inputSize={inputSize}
              $errors={$errors}
              $field={field}
              $paisSelecionado={$paisSelecionado}
              $selecionarPais={$selecionarPais}
              styleConteudoDropdown={styleConteudoDropdown}
            />
          )}
        />
      )}
    </ContainerEtapa>
  );
}
